import {
  makeVar
} from "@apollo/client";

export const localErrorsVar = makeVar( [] );